import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { footerLegalLinks } from '../../legal/legalPages';
import styles from './LegalFooterLinks.module.scss';

export function LegalFooterLinks({ className = '' }) {
  const { t } = useTranslation();
  const wrapperClass = [styles.links, className].filter(Boolean).join(' ');

  return (
    <nav className={wrapperClass} aria-label={t('legal.footerAria')}>
      {footerLegalLinks.map((entry) => (
        <Link key={entry.path} to={entry.path}>
          {t(entry.labelKey)}
        </Link>
      ))}
    </nav>
  );
}
